/* global axios */
import ApiClient from './ApiClient';

class SoftphoneExtensionsAPI extends ApiClient {
  constructor() {
    super('softphone_extensions', { accountScoped: true });
  }

  regeneratePassword(id) {
    return axios.post(`${this.url}/${id}/regenerate_password`);
  }
}

export default new SoftphoneExtensionsAPI();
